import * as orderApi from '../../api/orderApi'

const state = {
		ServiceShopSysNo:null,//当前门店ID
		KsShopID: "",//快手门店ID
		DouyinShopID: "",//抖音门店ID
		Code: String,
		Data: {}
}
const getters = {

}
const actions = {
		//查询一物一码
		async GetOneCode({ commit }, Code) {
				const response = await orderApi.GetOneCode(Code);
				commit('GetOneCode', response);
				return response;
		},
		async NewKsShopID({ commit }, params) {
				commit('setKsShopID', params);
		},
		async NewDouyinShopID({ commit }, params) {
				commit('setDouyinShopID', params);
		},
		async NewServiceShopSysNo({ commit }, params) {
				commit('setServiceShopSysNo', params);
		},
}

const mutations = {
		GetOneCode(state, data) //查询一物一码
		{
				state.Data = data
		},
		setKsShopID(state, data) {
				if (state.KsShopID != data) {
						state.KsShopID = data
				}
		},
		setDouyinShopID(state, data) {
				if (state.DouyinShopID != data) {
						state.DouyinShopID = data
				}
		},
		setServiceShopSysNo(state, data) {
				if (state.ServiceShopSysNo != data) {
						state.ServiceShopSysNo = data
				}
		},
}

export default {
		namespaced: true,
		getters,
		state,
		actions,
		mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/setorder.js